import { postV1CheckpointResponsesUploadUrls } from '@/api/client/sdk.gen'
import { uploadToStorage } from '@/integrations/firebase'

type ImageRecord = {
  path: string
  name: string
}

export const uploadImageFiles = async (
  workOrderId: string,
  files: File[],
): Promise<ImageRecord[]> => {
  if (files.length === 0) return []

  const { data, error } = await postV1CheckpointResponsesUploadUrls({
    body: {
      workOrderId,
      files: files.map(f => ({ name: f.name })),
    },
  })

  if (error || !data) throw new Error('Failed to get upload URLs')

  return await Promise.all(
    files.map(async (file, idx) => {
      const path = data.imageUrls[idx]
      if (!path) throw new Error('Missing upload URL for file')

      await uploadToStorage(path, file)

      return {
        path: path,
        name: file.name,
      }
    }),
  )
}
